/****   request.js   ****/
// 导入axios
import axios from 'axios';
// 使用element-ui Message做消息提醒
import { Message } from 'element-ui';
import store from '@/store/store';
import * as types from '../store/mutation-types';
import NodeRSA from 'node-rsa';
import CryptoJS  from 'crypto-js';
import { randomGenerate } from 'jyutils/utils';

//1. 创建新的axios实例，
const service = axios.create({
  // 公共接口--这里注意后面会讲
  // baseURL: process.env.VUE_APP_API,
  // 超时时间 单位是ms
  timeout: 600 * 1000,
});

// 加密
const initAesKey = (data, token, mtoken) => {
  // 生成AES密钥及向量
  const keyStr = randomGenerate(16);
  const ivStr = randomGenerate(16);

  // ⽣成AES 密钥和向量
  let key = CryptoJS.enc.Utf8.parse(keyStr); // AES密钥
  let iv = CryptoJS.enc.Utf8.parse(ivStr); // AES向量

  // 加密提交内容
  let encry = null;
  if (data) {
    encry = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(JSON.stringify(data)), // 加密提交内容
      key, // AES密钥
      {
        iv: iv, // AES向量
        mode: CryptoJS.mode.CBC, // 指定CBC模式
        padding: CryptoJS.pad.Pkcs7 // 指定pkcs7填充模式
      }
    );
  }
  // 加密token
  let encry_token = null;
  // console.log('token', token)
  if (token) {
    encry_token = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(token), // 加密提交内容
      key, // AES密钥
      {
        iv: iv, // AES向量
        mode: CryptoJS.mode.CBC, // 指定CBC模式
        padding: CryptoJS.pad.Pkcs7 // 指定pkcs7填充模式
      }
    );
  }
  // 加密mtoken
  let encry_mtoken = null;
  // console.log('mtoken', mtoken)
  if (mtoken) {
    encry_mtoken = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(mtoken), // 加密提交内容
      key, // AES密钥
      {
        iv: iv, // AES向量
        mode: CryptoJS.mode.CBC, // 指定CBC模式
        padding: CryptoJS.pad.Pkcs7 // 指定pkcs7填充模式
      }
    );
  }

  const publickey = store.getters.publickey;
  // console.log('publickey', publickey)
  // 加密AES密钥及向量
  const pubKey = new NodeRSA(publickey, 'pkcs8-public');
  pubKey.setOptions({ encryptionScheme: 'pkcs1' }); // 指定RSA加密协议，pkcs1 或 pkcs1_oaep，默认pkcs1_oaep
  const cryptStr = pubKey.encrypt(keyStr + ivStr, 'base64');

  return {
    key: key,
    iv: iv,
    'e-key': cryptStr,
    encry: encry ? encry.toString() : null,
    encry_token: encry_token ? encry_token.toString() : null,
    encry_mtoken: encry_mtoken ? encry_mtoken.toString() : null
  }
}

// 解密返回数据
const decry4Aes = (data, aes) => {
  if (data.encry_str && aes) {
    const decrypt = CryptoJS.AES.decrypt(data.encry_str, aes.key, {
      iv: aes.iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedStr.toString());
  }
  return data;
}


// 2.请求拦截器
service.interceptors.request.use(config => {
  
  /*
  //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等，根据需求去添加
  config.data = JSON.stringify(config.data); //数据转化,也可以使用qs转换
  config.headers = {
    'Content-Type': 'application/x-www-form-urlencoded' //配置请求头
  }
  //注意使用token的时候需要引入cookie方法或者用本地localStorage等方法，推荐js-cookie
  const token = getCookie('名称'); //这里取token之前，你肯定需要先拿到token,存一下
  if (token) {
    config.params = {
      'token': token
    } //如果要求携带在参数中
    config.headers.token = token; //如果要求携带在请求头中
  }
  */

  // console.log(config.url)
  // console.log(config.headers.Authorization)

  // 如果需要加密
  if (config.encry) {
    const Authorization = config.headers?.Authorization ?? null;
    const mtoken = config.headers?.mtoken ?? null;

    const aes = initAesKey(config.origData || config.data || null, Authorization ? store.getters.token : null, mtoken ? store.getters.mtoken : null);
    config.aes = aes;
    config.headers.Authorization = aes.encry_token || '';
    config.headers.mtoken = aes.encry_mtoken || '';
    config.headers['e-key'] = aes['e-key'];
    if (config.encry_data) {
      if (!config.origData) {
        config.origData = config.data;
      }
      config.data = aes.encry;
    }
  }
  
  config.retryTimes = 3;  // 请求重试次数
  // console.log(config)
  
  return config;
}, error => {
  Promise.reject(error)
})

// 3.响应拦截器
service.interceptors.response.use(response => {
  //接收到响应数据并成功后的一些共有的处理，关闭loading等
  const config = response.config;
  const json = response.data;
  // console.log('response...111', response)

  // 解密返回数据
  let obj = response.data?.obj ?? null;
  if (obj && config.aes) {
    obj = decry4Aes(obj, config.aes);
    response.data.obj = obj;
  }
  
  if (json && json[types.KEY_STATUS]) {
    if (json[types.KEY_STATUS] == types.CODE_ERROR) {
      if (json.obj && (json.obj.refreshkey || json.obj.refreshkey2)) {
        // 重试
        let config = response.config;
        if (!config || !config.retryTimes) return Promise.reject(response);
        const { __retryCount = 0, retryDelay = 300, retryTimes } = config;
        // 在请求对象上设置重试次数
        config.__retryCount = __retryCount;
        // 判断是否超过了重试次数
        if (__retryCount >= retryTimes) {
          return Promise.reject(response);
        }
        // 增加重试次数
        config.__retryCount++;
        // 延时处理
        const delay = new Promise((resolve) => {
          // 请求新的publickey
          store.dispatch('publickey', {
            callback: () => {
              setTimeout(() => {
                resolve();
              }, retryDelay);
            }
          });
        });
        // 重新发起请求
        return delay.then(function () {
          return service(config);
        });

        // if (json.obj.refreshkey) {
        //   Message.error('publicKey 已过期，请重试！');
        // }
      }
    }
    if (json[types.KEY_STATUS] == types.CODE_TIMEOUT) {
      store.commit(types.JY_LOGOUT);
    }
  }

  return response
}, error => {
  // console.log('error', error)
  /***** 接收到异常响应的处理开始 *****/
  if (error && error.response) {
    // 1.公共错误处理
    // 2.根据响应码具体处理
    switch (error.response.status) {
      case 400:
        error.message = '错误请求';
        break;
      case 401:
        error.message = '未授权，请重新登录';
        break;
      case 403:
        error.message = '拒绝访问';
        break;
      case 404:
        error.message = '请求错误,未找到该资源';
        // window.location.href = "/NotFound";
        break;
      case 405:
        error.message = '请求方法未允许';
        break;
      case 408:
        error.message = '请求超时';
        break;
      case 500:
        error.message = '服务器端出错';
        break;
      case 501:
        error.message = '网络未实现';
        break;
      case 502:
        error.message = '网络错误';
        break;
      case 503:
        error.message = '服务不可用';
        break;
      case 504:
        error.message = '网络超时';
        break;
      case 505:
        error.message = 'http版本不支持该请求';
        break;
      default:
        error.message = `连接错误${error.response.status}`;
    }
  } else {
    // 超时处理
    if (JSON.stringify(error).includes('timeout')) {
      Message.error('服务器响应超时，请刷新当前页');
    }
    Message.error('连接服务器失败');
  }

  if (error.message) {
    Message.error(error.message);
  }
  /***** 处理结束 *****/
  //如果不需要错误处理，以上的处理过程都可省略
  return Promise.reject(error.response);
})
//4.导入文件
export default service;